/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Manager_Permissions_NoteInputs */

const en_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If no groups are selected, all team members can access this guide. Admin and Manager roles always have access regardless of group assignments.`)
};

const fr_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si aucun groupe n’est sélectionné, tous les membres de l’équipe peuvent accéder à ce guide. Les rôles Administrateur et Manager ont toujours accès, quel que soit l’affectation aux groupes.`)
};

const de_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn keine Gruppen ausgewählt sind, haben alle Teammitglieder Zugriff auf diesen Leitfaden. Administratoren und Manager haben unabhängig von der Gruppenzugehörigkeit immer Zugriff.`)
};

const it_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se non viene selezionato alcun gruppo, tutti i membri del team potranno accedere a questa guida. I ruoli di amministratore e responsabile hanno sempre accesso, indipendentemente dalle assegnazioni di gruppo.`)
};

const ru_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если группы не выбраны, доступ к этому руководству имеют все члены команды. Администраторы и менеджеры всегда имеют доступ независимо от назначения в группу.`)
};

const es_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si no se selecciona ningún grupo, todos los miembros del equipo podrán acceder a esta guía. Los roles de administrador y gerente siempre tendrán acceso, independientemente de las asignaciones de grupo.`)
};

const zh_cn2_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果未选择任何分组，所有团队成员均可访问本指南。管理员和经理角色始终拥有访问权限，不受分组情况的影响。`)
};

const ja_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グループが選択されていない場合は、すべてのチームメンバーがこのガイドにアクセスできます。管理者とマネージャーの役割は、グループの割り当てに関係なく常にアクセスできます。`)
};

const hi_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यदि कोई समूह चयनित नहीं है, तो टीम के सभी सदस्य इस गाइड तक पहुंच सकते हैं। समूह असाइनमेंट की परवाह किए बिना, एडमिन और मैनेजर भूमिकाओं वाले सदस्यों को हमेशा एक्सेस प्राप्त होता है।`)
};

const pt_pt2_knp_manager_permissions_note = /** @type {(inputs: Knp_Manager_Permissions_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se nenhum grupo for selecionado, todos os membros da equipe poderão acessar este guia. Os membros com funções de Administrador e Gerente sempre terão acesso, independentemente da atribuição de grupos.`)
};

/**
* | output |
* | --- |
* | "If no groups are selected, all team members can access this guide. Admin and Manager roles always have access regardless of group assignments." |
*
* @param {Knp_Manager_Permissions_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_manager_permissions_note = /** @type {((inputs?: Knp_Manager_Permissions_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Manager_Permissions_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_manager_permissions_note(inputs)
	if (locale === "de") return de_knp_manager_permissions_note(inputs)
	if (locale === "it") return it_knp_manager_permissions_note(inputs)
	if (locale === "ru") return ru_knp_manager_permissions_note(inputs)
	if (locale === "es") return es_knp_manager_permissions_note(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_manager_permissions_note(inputs)
	if (locale === "ja") return ja_knp_manager_permissions_note(inputs)
	if (locale === "hi") return hi_knp_manager_permissions_note(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_manager_permissions_note(inputs)
	return en_knp_manager_permissions_note(inputs)
});